import React, { useEffect } from "react";
import { Button, Form, Input, message } from "antd";
import {
  ArrowRightOutlined,
  LockOutlined,
  MailOutlined,
  SafetyCertificateOutlined
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { postRequest } from '../appRedux/actions/Axios'
import { NotificationContainer, NotificationManager } from "react-notifications";
import { NotificationErrorTimeOut } from '../constants/Config'
import DaLogo from '../assets/images/tu-gestor-fiscal-logo.png'
import {
  hideMessage,
  showAuthLoader,
  hideAuthLoader,
  userSignIn,
  setEncriptionUser,
  setCompanyPaymentBlocked,
  startCompanyPaymentSession
} from "appRedux/actions/Auth";

import CircularProgress from "components/CircularProgress/index";
import { isCompanyAccessError } from '../util/companyPaymentAccess';

const FormItem = Form.Item;

const SignIn = () => {
  const [form] = Form.useForm();

  const dispatch = useDispatch();
  const { loader, alertMessage, showMessage } = useSelector(({ auth }) => auth);
  const history = useHistory();

  useEffect(() => {
    if (showMessage) {
      setTimeout(() => {
        dispatch(hideMessage());
      }, 100);
    }

    if (localStorage.getItem("token") !== null) {
      history.push('/');
    }

  });
  const handleSubmit = (e) => {
    form.validateFields().then(values => {
      dispatch(showAuthLoader());
      dispatch(postRequest(`/users/authenticate`, {}, values))
        .then((r) => {
          const { payload: { data } } = r;
          if (typeof data !== "undefined") {
            dispatch(setCompanyPaymentBlocked(null));
            dispatch(startCompanyPaymentSession(data.token, data.paymentWarningCompanyIds));
            dispatch(setEncriptionUser(
              {
                email: data.user.email,
                firstName: data.user.person.firstName,
                lastName: data.user.person.lastName,
                userAccessId: data.user.userAccessId,
                CasherId:data?.user?.casher?.id,
                UserRolePOS: data?.user?.casher?.role
              }
            ))
            dispatch(userSignIn(data));
          }
        })
        .catch((e) => {
          if (isCompanyAccessError(e.error || e)) return;
            console.log(e);
          if (typeof e.error.response == "undefined") {
            NotificationManager.error("", e.toString(), NotificationErrorTimeOut);
            dispatch(hideAuthLoader())
            return;
          }

          const { error: { response } } = e;
          dispatch(hideMessage());
          if (typeof response != "undefined") {
            if (response.data === null) {
              NotificationManager.error("Ha ocurrido un error, si el problema persiste contacte a su administrador.", "Error!", NotificationErrorTimeOut);
              dispatch(hideAuthLoader())
            } else {
              NotificationManager.error("", response.data.message, NotificationErrorTimeOut);
              dispatch(hideAuthLoader())
            }
          } else {
            NotificationManager.error("Ha ocurrido un error, si el problema persiste contacte a su administrador.", "Error!", NotificationErrorTimeOut);
            dispatch(hideAuthLoader())
          }
        });
    }).catch(error => {
      console.error(error);
    })

    // e.preventDefault();
    //  props.form.validateFields((err, values) => {
    //   if (!err) {
    //     dispatch(showAuthLoader());
    //     dispatch(postRequest(`/users/authenticate`,{},values))
    //     .then((r)=>{
    //         const {payload:{data}}=r;
    //         if(typeof data!=="undefined"){
    //             dispatch(userSignIn(data));
    //         }})
    //     .catch((e)=>{
    //         const {error:{response}}=e;
    //         dispatch(hideMessage());
    //         if(typeof response!="undefined"){
    //             NotificationManager.error("",response.data.message,NotificationErrorTimeOut);
    //         }else{
    //           NotificationManager.error("Ha ocurrido un error, si el problema persiste contacte a su administrador.","Error!",NotificationErrorTimeOut);
    //         }
    //     });
    //   }
    // });
  };
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    labelAlign: "left"

  };

  return (
    <div className="dasi-login">
      <span className="dasi-login__glow dasi-login__glow--one" aria-hidden="true" />
      <span className="dasi-login__glow dasi-login__glow--two" aria-hidden="true" />

      <main className="dasi-login__shell">
        <section className="dasi-login__visual" aria-label="TuGestorFiscal, sistema contable">
          <div className="dasi-login__brand">
            <span className="dasi-login__brand-mark">
              <img src={DaLogo} alt="Logo de D.A Sistemas Integrados" />
            </span>
            <span>
              <strong>Tu Gestor Fiscal</strong>
            </span>
          </div>

          <div className="dasi-login__intro">
            <span className="dasi-login__eyebrow">Contabilidad simple y ordenada</span>
            <h1>Tu contabilidad, siempre bajo control.</h1>
            <p>Registra movimientos, revisa tus cuentas y consulta reportes con información clara para decidir mejor.</p>

          </div>

          <div className="dasi-login__visual-foot">
            <span>Asientos</span>
            <span>Conciliaciones</span>
            <span>Reportes</span>
          </div>
        </section>

        <section className="dasi-login__access">
          <div className="dasi-login__form-wrap">
            <span className="dasi-login__secure-label">
              <SafetyCertificateOutlined /> Acceso seguro
            </span>
            <h2>Inicia sesión</h2>
            <p className="dasi-login__subtitle">
              Ingresa tus datos para entrar a{" "}
              <span className="dasi-login__product-name">Tu Gestor Fiscal</span>.
            </p>

            <Form
              {...formItemLayout}
              onFinish={handleSubmit}
              form={form}
              name="SignIn"
              layout="vertical"
              className="dasi-login__form">

              <FormItem
                name="Username"
                initialValue=""
                label="Correo electrónico"
                rules={[{
                  required: true, type: 'email', message: 'Ingresa un correo electrónico válido.',
                }]}
              >
                <Input
                  prefix={<MailOutlined />}
                  placeholder="nombre@empresa.com"
                  autoComplete="email"
                  size="large"
                />
              </FormItem>
              <FormItem
                name="Password"
                label="Contraseña"
                initialValue=""
                rules={[{ required: true, message: 'Ingresa tu contraseña.' }]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Tu contraseña"
                  autoComplete="current-password"
                  size="large"
                />
              </FormItem>
              <FormItem className="dasi-login__submit-item">
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  size="large"
                  disabled={loader}
                  className="dasi-login__submit"
                >
                  <span>Iniciar sesión</span>
                  <ArrowRightOutlined />
                </Button>
              </FormItem>
            </Form>

            <p className="dasi-login__security-note">
              <LockOutlined /> Tus credenciales viajan de forma segura.
            </p>
          </div>

        </section>

        {loader ?
          <div className="dasi-login__loader">
            <CircularProgress />
          </div> : null}
        {showMessage ?
          message.error(alertMessage.toString()) : null}
      </main>
      <NotificationContainer />
    </div>
  );
};

const WrappedNormalLoginForm = (SignIn);

export default WrappedNormalLoginForm;
